// extracted by mini-css-extract-plugin
module.exports = {"ant-form-item":"generalMoral_ant-form-item_taIbB"};